<template>



    <div class="filterRow d-flex  mb-2 p-3 bg-white mobile_side_dc">
        <div class="d-flex mr-3">
            <div class="f-col">
                <label class="mobile_lbl">In Date Time</label>
                <kendo-datepicker class="w-100 date_pik_mbl" v-model="FromDate" :name="'Date of start'" :format="'dd/MM/yyyy'"
                    placeholder="From Date"></kendo-datepicker>
            </div>
        </div>
        <div class="d-flex mr-3">
            <div class="f-col">
                <label class="mobile_lbl">Out Date Time</label>
                <kendo-datepicker class="w-100 date_pik_mbl" v-model="ToDate" :name="'Date of start'" :format="'dd/MM/yyyy'"
                    placeholder="To Date"></kendo-datepicker>
            </div>
        </div>
        <div class="d-flex mr-3">
            <div class="f-col">
                <label class="mobile_lbl">Geofence ID</label>
                <!-- <dropdownlist style="width: 190px" :data-items="getVehicles" :text-field="'rtoNumber'"
                    :data-item-key="'id'" v-model="searchingVehicleRtoNumber">
                </dropdownlist> -->
                <!-- {{getGeofenceReportID}} -->
                <dropdownlist :data-items="getGeofenceReportID"  :default-item="defaultTeam" style="width: 190px" :data-item-key="'id'"
                    :filterable="true" :text-field="'metadata.geofence.properties.geofenceName'"  v-model="geofenceId"
                    :required="true">

                </dropdownlist>
            </div>
        </div>
          <div class="d-flex mr-3">
        <div title="Summary Report" v-if="isSummeryReportExist" class="rf-col mt-1 ml-2 mt-4" style="width: 79px;">
            <div class="d-flex">
              <label class="mt-2 mr-1">Summary</label>
                <div class="checkbox ml-0 mr-2 mt-2">
                <input type="checkbox" v-model="showAllRec" class="{'active-track':track=='all'}" @change="$emit('onChangeSummaryRec',$event)"/>
                </div>
            </div>
            </div>
         </div>
        <div class="d-flex mr-3">
            <div class="f-col">
                <div class="p-2"></div>
                <kendo-button title="Search" :style="{ marginTop: '6px' }" class="k-primary ml-1"
                    @click="onChange">Search</kendo-button>
            </div>
        </div>
    </div>

</template>

<script>
import { notifyWarn } from '@/utils/notification-helper';

import { formatISO} from '@/utils/date-helpers'
import { createNamespacedHelpers } from "vuex";
const {mapGetters ,mapActions} = createNamespacedHelpers("reports");
export default {
  data() {
    return {
      RosterType: "General",
      FromDate:new Date(new Date().setHours(0,0,0,0)),
      ToDate:new Date(new Date().setHours(23,59,0,0)),
      Duration:'',
      geoFenceFilter: "",
      geofenceId:null,
      defaultTeam:{rtoNumber:"All",id:""},
    };
  },
  props:["field","isSummeryReportExist"],
  methods: {
      ...mapActions(["fetchGeofenceId"]),
    onChange() {
        let t = this
      if(!(t.FromDate&&t.ToDate )){
        notifyWarn("Please select all the filters");

        return
      }
      this.$emit("update", {
        FromDate: formatISO(this.FromDate),
        ToDate: formatISO(this.ToDate),
        TenantId:this.getTenantId,
        GeofenceId: this.geofenceId?this.geofenceId.id:'',
        //RTONumber:this.RTONumber?this.RTONumber.rtoNumber:'',
        _query: {
          FromDate: formatISO(this.FromDate),
          ToDate: formatISO(this.ToDate),
          TenantId:this.getTenantId,
          GeofenceId: this.geofenceId?this.geofenceId.id:'',
          //GeofenceId:(this.geofenceId && this.geofenceId.id)?this.geofenceId:'',
        
        },
      });
    },
     filterChange(e) {
      this.geoFenceFilter = e.filter.value ? e.filter.value.toLowerCase() : "";
    }
  },
    computed: {
   ...mapGetters([ "getVehicles","getGeofenceReportID","getTenantId"]),
    // getfilterGeofenceId:(state)=>state.geofenceId,   
    },
    mounted (){
        this.fetchGeofenceId();
        console.log("#fetchdata")
    }
};
</script>

<style>
</style>